//angular components
import { Component, OnDestroy, OnInit } from '@angular/core';
import { DataSharingService } from 'src/app/_core/services';
import { SharedGlobalService } from 'src/app/_core/services/api';
import { MetaService } from 'src/app/_core/services/meta.service';
//models
import { CompanyCurrency, RestResponse, SalesChannelDataDashboard } from 'src/app/_shared/models';
import { Unsubscriber } from 'src/app/_shared/unsubscriber/unsubscriber';

@Component({
  selector: 'app-sales-channels-dashboard',
  templateUrl: './sales-channels-dashboard.component.html',
  styleUrls: ['./sales-channels-dashboard.component.scss']
})
export class SalesChannelsDashboardComponent implements OnInit, OnDestroy {

  companyCurrencyBase: CompanyCurrency;
  collectionOfChannels: Array<SalesChannelDataDashboard> = [];
  isChannelError: boolean = false;
  isChannelsReady: boolean = false;

  private subs = new Unsubscriber();

  constructor(
    private meta: MetaService,
    private shareData: DataSharingService,
    private sharedGlobalService: SharedGlobalService,
    ) {
      // Subscribe to company currency base
    this.subs.addSub = this.shareData.currentCompanySettingsCurrencyBaseSource.subscribe(data => {
      this.companyCurrencyBase = data.currencyBase;
    });
  }

  ngOnInit(): void {
    this.getChannels();
  }

  getChannels() {
    this.subs.addSub = this.sharedGlobalService.getNotificationsChannels().subscribe(
        (res: RestResponse) => {
          this.buildCollection(<Array<any>>res.data);
          this.isChannelError = false;
          this.isChannelsReady = true;
        },
        (err: RestResponse) => {
          this.meta.showNotification(err);
          this.isChannelError = true;
          this.isChannelsReady = true;
        }
      );
  }

  buildCollection(channels:any) {
    this.collectionOfChannels = [];
    if (channels.length > 0) {
      channels.forEach(element => {
        element.data.forEach(data => {
          let itemValue: SalesChannelDataDashboard = {
            integrationName: null,
            displayName: null,
            customerCount: null,
            subscriptionCount: null,
            invoiceCount: null,
            invoiceAmount: null
          };
          
          itemValue.integrationName = element.integrationName;
          itemValue.displayName = data.displayName;
          itemValue.customerCount = data.customerCount;
          itemValue.subscriptionCount = data.subscriptionCount;
          itemValue.invoiceCount = data.invoiceCount;
          itemValue.invoiceAmount = data.invoiceAmount;
  
          this.collectionOfChannels.push(itemValue);
        });
      });
    }
  }
  
  ngOnDestroy() {
    this.subs.unsubscribe();
  }

}
